import { Component, inject, input, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

import { BannerComponent } from '../banner/banner.component';
import { ButtonDirective } from '../button/button.directive';
import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'tt-sticky-header',
  templateUrl: './sticky-header.component.html',
  standalone: true,
  styleUrls: ['./sticky-header.component.scss'],
  imports: [TranslocoPipe, FormsModule, MatIconModule, IconDirective, BannerComponent, ButtonDirective],
})
export class StickyHeaderComponent {
  @Input() public isSidebarOpen: boolean;
  @Input() public title: string;
  @Input() public organisationImage?: string;
  @Input() public isPublicPage?: boolean;
  public showContentChangedBanner = input<boolean>(false);
  public showContentEditingBanner = input<boolean>(false);

  private router = inject(Router);

  protected navigateBack() {
    this.router.navigateByUrl('/smartbook');
  }
}
